import {Navigate} from 'react-router-dom';
import {PlatformLoader, SimplePageLayout} from '@flexinet/ui-components';
import {useApplicationProducts, ApplicationProductsComponent} from '@flexinet/pricing-components';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {SubscriptionStatusBanner} from "../../../components/SubscriptionStatusBanner.tsx";
import {useVerifiedPermissions} from "@flexinet/auth-components";
import {actionConstants} from "../../../config/rbac/actions.ts";
import {useEffect} from "react";

export const IndexPage = () => {

    const {
        status,
        authorizing,
        allowedActions,
    } = useVerifiedPermissions();

    const {
        items: applicationProducts,
        handleFetchRecords
    } = useApplicationProducts();

    // GetDashboard, not a products-specific action. The deployed policy store
    // declares nine actions and none of them names this page; an action absent
    // from the schema never matches a permit statement, so gating on one would
    // deny every non-admin silently and dead-end the header Upgrade button.
    // GetDashboard is deployed in all three stages and permitted for ordinary
    // users, which is the population this page is for. FNP-1410.
    const permitted = allowedActions.includes(actionConstants.GET_DASHBOARD);

    useEffect(() => {
        if (permitted) {
            handleFetchRecords()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permitted]);

    // The provider starts with authorizing=true and an empty allowedActions,
    // so redirecting before the decisions land would bounce every user off the
    // page the Upgrade button just sent them to.
    if (authorizing) {
        return <PlatformLoader message='Loading products...Please wait!'/>;
    }

    // Interim until FNP-1749. A failed check is not a DENY: hand it to the
    // route's existing errorElement rather than redirect. FNP-1728.
    if (status === 'failed') {
        throw new Error("We couldn't check your permissions. Reload the page to try again.");
    }

    if (!permitted) {
        return <Navigate to='/'/>;
    }

    const products = applicationProducts
        ?.map((applicationProduct) => applicationProduct.product)
        .filter((product): product is NonNullable<typeof product> => product != null);

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >

            {products ?
                <>
                    <SubscriptionStatusBanner/>
                    <ApplicationProductsComponent products={products}/>
                </> : null}

        </SimplePageLayout>
    );
};
